import { useState, useEffect } from "react";

const ScrollProgress = () => {
  const [atTop, setAtTop] = useState(true);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setAtTop(scrollTop < 50); // tweak threshold if needed
  };

  const scrollHandler = () => {
    if (atTop) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div style={styles.wrapper} onClick={scrollHandler} title={atTop ? "Go to Bottom" : "Back to Top"}>
      <button className="btn btn-warning rounded-circle shadow">
        <i className={`fas ${atTop ? "fa-angle-down" : "fa-angle-up"}`}></i>
      </button>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    bottom: "15px",
    right: "15px",
    zIndex: 1000,
    cursor: "pointer",
  },
};

export default ScrollProgress;
